import React, { useState, useEffect } from "react";
import Wrapper from "../../UI/Wrapper";
import image1 from "../../../Icons/LeadDataImage1.png";
import image2 from "../../../Icons/Mask group.png";
import image3 from "../../../Icons/Maskgroup2.png";
import image4 from "../../../Icons/Maskgroup4.png";
import image5 from "../../../Icons/Maskgroup5.png";
import image6 from "../../../Icons/Maskgroup6.png";
import image7 from "../../../Icons/Maskgroup7.png";
import image8 from "../../../Icons/Maskgroup8.png";
import image9 from "../../../Icons/Maskgroup9.png";
import icon_user from "../../../Icons/icon_user.png";
import axios from "axios";
import { DateRangePicker } from "react-date-range";
import TwoLevelPieChart from "../../../components/DashboardComponents/TwoLevelPieChart/TwoLevelPieChart";
import Card from "../../../components/DashboardComponents/Card/Card";
import icon1 from "../../../Icons/CardIcon1.png";
import icon2 from "../../../Icons/icon2.png";
import icon3 from "../../../Icons/icon3.png";
import icon4 from "../../../Icons/icon4.png";
import TotalBookingAmount from "../../../components/DashboardComponents/TotalBookingAmount/TotalBookingAmount";

import "../LeadData/LeadData.css";
import { Height } from "@mui/icons-material";

const LeadData = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [leadDataResponse, setLeadDataResponse] = useState([]); 
  const [initialLeadData, setInitialLeadData] = useState([]);

  function getLeadData() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = formatDate(selectionRange.startDate);

    let enddate = formatDate(selectionRange.endDate);
    if (dateRange === "Custom Dates") {
      startdate = "";
      enddate = "";
    }

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/getdashboarddetail?startDate=${startdate}&enddate=${enddate}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setLeadDataResponse(response.data.data[0]);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }
  function clearFilter() {
    setDateRange("Custom Dates");
    setLeadDataResponse(initialLeadData); // Reset to initial data
  }

  const [isOpen, setIsOpen] = useState(false);
  const [dateRange, setDateRange] = useState("Custom Dates");
  const togglePicker = () => {
    setDateRange(
      formatDate(selectionRange.startDate) +
      " - " +
      formatDate(selectionRange.endDate)
    );
    setIsOpen(!isOpen);
  };

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const handleSelect = (ranges) => {
    // ranges contains an object with startDate and endDate
    setSelectionRange(ranges.selection);
  };

  const clearDateRange = () => {
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
  };

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}userget/getdashboarddetail?startDate=&enddate=`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response) {

            if (response.data.data != null) {
              setLeadDataResponse(response.data.data[0]);
              setInitialLeadData(response.data.data[0]);
            }

          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  return (
    <>
      {/* <div className="filterdataDiv"> */}
      <div
        className="content-container-LeadList innerConatiner"
        style={{ overflowX: "clip" }}
      >
        <div className="container-fluid" style={{ marginTop: "3rem" }}>
          <div style={{ display: "flex" }}>
            <div
              className=" headerButton"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                gap: "10px",
                // justifyContent: "left",
                height: "69px",
                paddingBottom: "3px",
              }}
            >
              <div className="allFilterButtons">
                <div className="filter-icon">
                  <img
                    src={require("../../../Icons/filterIcon.png")}
                    alt="filter"
                  />
                  FILTER
                </div>
                <div style={{ paddingTop: "6px" }}>
                  <span>
                    Compare{" "}
                    <hr
                      style={{
                        width: "1px",
                        height: "20px", // Adjust height to match surrounding elements
                        backgroundColor: "black",
                        border: "none",
                        transform: "none",
                        position: "relative",
                        marginLeft: "92px",
                        marginTop: "-21px", // No need to rotate since it's a vertical line
                      }}
                    />
                  </span>
                </div>

                <div>
                  <button
                    style={{
                      marginBottom: "1rem",
                      width: "12rem",
                      height: "2.5rem",
                      borderRadius: "0.5rem",
                      fontSize: "13px",
                    }}
                    onClick={togglePicker}
                  >
                    {" "}
                    <b> {dateRange}</b>
                  </button>
                  {isOpen && (
                    <div
                      style={{
                        position: "absolute",
                        zIndex: 999,
                        border: "solid 1px black",
                        marginLeft: "-13pc",
                        width: "35pc",
                        background: "white",
                      }}
                    >
                      <DateRangePicker
                        ranges={[selectionRange]}
                        onChange={handleSelect}
                      />
                      <button
                        onClick={clearDateRange}
                        style={{
                          marginBottom: "1rem",
                          width: "5rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          position: "relative",
                          top: "1px",
                          left: "22pc",
                          color: "red",
                          border: "none",
                        }}
                      >
                        Reset
                      </button>
                      <button
                        style={{
                          marginBottom: "1rem",
                          width: "7rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          position: "relative",
                          top: "1px",
                          left: "22pc",
                          backgroundColor: "#5B489D",
                          color: "White",
                        }}
                        onClick={togglePicker}
                      >
                        Done
                      </button>
                    </div>
                  )}
                </div>
                <div>
                  <div
                    className="fafilterApply"
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <div
                      className="Leadlist-filter"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <button onClick={getLeadData} className="">
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    className="fafilterresetApply"
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <div
                      className="Leadlist-filter-clear"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <button onClick={clearFilter} className="">
                        Clear Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="right-div"
                style={{
                  border: "1.5px solid #0C9800",
                  borderRadius: "7.5px",
                  padding: "5px",
                  width: "170px",
                  paddingLeft: "28px",
                  height: "36px",
                }}
              >
                <img
                  src={icon_user}
                  style={{
                    height: "15px",
                    width: "15px",
                    marginLeft: "-15px",
                  }}
                  alt="icon"
                />
                Active Users
                <div
                  style={{
                    height: "34px",
                    width: "35px",
                    backgroundColor: "#0C9800",
                    position: "absolute",
                    borderRadius: "7.5px",
                    marginLeft: "6.6rem",
                    marginTop: "-1.8rem",
                  }}
                >
                  <span>

                    <h5
                      style={{
                        padding: "5px",
                        paddingLeft: "13px",
                        color: "#FFFFFF",
                      }}
                    >
                      {leadDataResponse.active_users}
                    </h5>

                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: "22px",
        }}
      >
        <div>
          <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>Dashboard</h1>
        </div>
        <div className="directionThreeDivs">
          <div
            class="left-div"
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                border: "1px solid black",
                borderRadius: "7.5px",
                padding: "5px",
                width: "100px",
                paddingLeft: "28px",
                marginLeft: "4px",
              }}
            >
              <span class="bluedot"></span>
              Total
            </div>
            <div
              style={{
                border: "1px solid black",
                borderRadius: "7.5px",
                padding: "5px",
                width: "110px",
                paddingLeft: "28px",
                marginLeft: "10px",
              }}
            >
              <span class="greendot"></span>
              Today's
            </div>
          </div>
        </div>
      </div>

      <div
        className="Maindiv_leadData"
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div className="container firstContainer">
          <div className="c-containerFirst">
            <div className="row">
              <div className="col">
                <div className="imageStyle" style={{ background: "#5B489D" }}>
                  <img
                    className="imgdatatag"
                    src={image1}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>

                <h3>{leadDataResponse.total_lead}</h3>

                <span>Total Leads</span>
              </div>
              <div className="col">
                <div className="imageStyle" style={{ background: "#FA9A0B" }}>
                  <img
                    src={image2}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>

                <h3>{leadDataResponse.total_ul}</h3>

                <span>Total Untouched Leads</span>
              </div>
              <div className="col">
                <div className="imageStyle" style={{ background: "#DD4477" }}>
                  <img
                    src={image3}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>               
                  <h3>{leadDataResponse.total_conversion}</h3>                
                <span>Total Conversions</span>
              </div>
              <div className="col">
                <div className="imageStyle" style={{ background: "#44DDDD" }}>
                  <img
                    src={image3}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>               
                  <h3>{leadDataResponse.overall_conversions}</h3>               
                <span>Overall Conversions</span>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col">
                <div className="imageStyle" style={{ background: "#0C9800" }}>
                  <img
                    src={image4}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>
                
                  <h3>{leadDataResponse.total_ol}</h3>
               
                <span>Total Open Leads</span>
              </div>
              <div className="col">
                <div className="imageStyle" style={{ background: "#ED1F24" }}>
                  <img
                    src={image5}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>
                
                  <h3>{leadDataResponse.total_cl}</h3>
               
                <span>Total Close Leads</span>
              </div>
              <div className="col">
                <div className="imageStyle" style={{ background: "#0099C6" }}>
                  <img
                    src={image6}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>
                
                  <h3>{leadDataResponse.total_execution}</h3>
                
                <span>Total Executions</span>
              </div>
              <div className="col">
                <div className="imageStyle" style={{ background: "#B544DD" }}>
                  <img
                    src={image6}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>               
                  <h3>{leadDataResponse.total_refund}</h3>              
                <span>Total Refund</span>
              </div>
            </div>
          </div>
        </div>

        <div className="container secondContainer">
          <div className="c-containerSecond">
            <div className="row">
              <div className="col">
                <div className="imageStyle" style={{ background: "#5B489D" }}>
                  <img
                    src={image1}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>
                <h3>{leadDataResponse.today_lead}</h3>
                <span>Today's Leads</span>
              </div>
              <div className="col">
                <div className="imageStyle" style={{ background: "#FA9A0B" }}>
                  <img
                    src={image2}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>                
                  <h3>{leadDataResponse.today_ul}</h3>               
                <span>Today's Untouched Leads</span>
              </div>
              <div className="col">
                <div className="imageStyle" style={{ background: "#DD4477" }}>
                  <img
                    src={image7}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>              
                  <h3>{leadDataResponse.today_conversion}</h3>               
                <span>Today's Conversions</span>
              </div>
              <div className="col">
                <div className="imageStyle" style={{ background: "#44DDDD" }}>
                  <img
                    src={image7}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>                
                  <h3>{leadDataResponse.today_task}</h3>               
                <span>Today's Task</span>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col">
                <div className="imageStyle" style={{ background: "#0C9800" }}>
                  <img
                    src={image8}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>               
                  <h3>{leadDataResponse.today_ol}</h3>               
                <span>Today's Open Leads</span>
              </div>
              <div className="col">
                <div className="imageStyle" style={{ background: "#ED1F24" }}>
                  <img
                    src={image5}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>               
                  <h3>{leadDataResponse.today_cl}</h3>               
                <span>Today's Close Leads</span>
              </div>
              <div className="col">
                <div className="imageStyle" style={{ background: "#0099C6" }}>
                  <img
                    src={image1}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>               
                  <h3>{leadDataResponse.today_execution}</h3>               
                <span>Today's Executions</span>
              </div>
              <div className="col">
                <div className="imageStyle" style={{ background: "#B544DD" }}>
                  <img
                    src={image1}
                    alt="leadImage"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </div>                
                  <h3>{leadDataResponse.today_refund}</h3>               
                <span>Today's Refund</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          paddingTop: "30px",
          paddingBottom: "30px",
          height: "197px",
        }}
      >
        <div className="" style={{ width: "100%", height: "370px" }}>
          <table style={{ width: "100%", marginLeft: "0" }}>
            <tr>
              <td>                
                  <Card
                    heading="Todays follow up"
                    value={leadDataResponse.today_followup}
                    background="#0C9800"
                    borderRadius="10px"
                    icon={icon1}
                  />                
              </td>
              <td style={{ paddingLeft: "1rem" }}>
             
                  <Card
                    heading="Missed follow up"
                    value={leadDataResponse.pending_followup}
                    background="#DD4477"
                    borderRadius="10px"
                    icon={icon2}
                  />
               
              </td>
              <td style={{ paddingLeft: "1rem" }}>               
                  <Card
                    heading="Todays update"
                    value={leadDataResponse.today_update}
                    background="#0099C6"
                    borderRadius="10px"
                    icon={icon3}
                  />               
              </td>
              <td style={{ paddingLeft: "1rem" }}>               
                  <Card
                    heading="Conversion Ratio"
                    value={leadDataResponse.conversion_ratio}
                    background="#FA9A0B"
                    borderRadius="10px"
                    icon={icon4}
                  />                
              </td>
            </tr>
            {/* <br /> */}
            {/* <tr>
              <td>
                {leadDataResponse.map((item) => (
                  <Card
                    heading="Todays update"
                    value={item.today_update}
                    background="#0099C6"
                    borderRadius="10px"
                    icon={icon3}
                  />
                ))}
              </td>
              <td style={{ paddingLeft: "1rem" }}>
                {leadDataResponse.map((item) => (
                  <Card
                    heading="Conversion Ratio"
                    value={item.conversion_ratio}
                    background="#FA9A0B"
                    borderRadius="10px"
                    icon={icon4}
                  />
                ))}
              </td>
            </tr> */}
          </table>
        </div>
        {/* <div className="container" style={{ width: "50%", height: "370px" }}>
          <Wrapper className=" twoLevelPieChart  pie-chart-margin">
            <div style={{ display: "flex", height: "90%" }}>
              <div
                style={{
                  height: "99%",
                  width: "44%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <TwoLevelPieChart style={{ height: "50%", width: "50%" }} />
              </div>
              <div className="tableTargets">
                <table>
                  <tr>
                    <td>
                      <h6>Targets Achieved by Leads</h6>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ paddingBottom: "15%", fontSize: "36px" }}>
                      <h3 style={{ fontWeight: "700", color: "#6A6A6A" }}>
                        100 / 200
                      </h3>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Targets Achieved by Revenue</h6>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "36px" }}>
                      <h3 style={{ fontWeight: "700", color: "#6A6A6A" }}>
                        12.8 L / 20 L
                      </h3>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </Wrapper>
        </div> */}
      </div>

      <div
        className="bookingFourDivs"
        style={{ display: "flex", marginTop: "0" }}
      >
        <div className="container" style={{ width: "25%" }}>        
            <TotalBookingAmount
              text="Total Quotation Amount"
              value={leadDataResponse.total_booking_amount}
              borderColor="red"
              borderLeft="1rem solid #0C9800"
              imagesourcs={require("../../../Icons/totalBooking.png")}
            // amountImage
            />         
        </div>
        <div className="container" style={{ width: "25%" }}>
         
            <TotalBookingAmount
              text="Total Token Amount"
              value={leadDataResponse.total_token_amount}
              borderColor="red"
              borderLeft="1rem solid #5B489D"
              imagesourcs={require("../../../Icons/totalBooking2.png")}
            // amountImage
            />       
        </div>
        <div className="container" style={{ width: "25%" }}>         
            <TotalBookingAmount
              text="Total Execution Amount"
              value={leadDataResponse.total_sales_amount}
              borderColor="red"
              borderLeft="1rem solid #0099C6"
              imagesourcs={require("../../../Icons/totalBooking3.png")}
            // amountImage
            />
         
        </div>
        <div className="container" style={{ width: "25%" }}>
         
            <TotalBookingAmount
              text="Today's Quotation Amount"
              value={leadDataResponse.today_booking_amount}
              borderColor="red"
              borderLeft="1rem solid #FA9A0B"
              imagesourcs={require("../../../Icons/totalBooking5.png")}
            // amountImage
            />
          
        </div>
        <div className="container" style={{ width: "25%" }}>
         
            <TotalBookingAmount
              text="Today's Token Amount"
              value={leadDataResponse.today_token_amount}
              borderColor="red"
              borderLeft="1rem solid #B544DD"
              imagesourcs={require("../../../Icons/totalBooking6.png")}
            // amountImage
            />
       
        </div>
        <div className="container" style={{ width: "25%" }}>
        
            <TotalBookingAmount
              text="Today's Execution Amount"
              value={leadDataResponse.today_sales_amount}
              borderColor="red"
              borderLeft="1rem solid #0099C6"
              imagesourcs={require("../../../Icons/totalBooking3.png")}
            // amountImage
            />
        
        </div>
      </div>
    </>
  );
};

export default LeadData;
